import 'twin.macro';

import { Card, Image, Stack, Text } from '@cheqroom/ui';
import { FC } from 'react';

import kitPreviewLogo from '../../../../public/assets/images/kit-preview.png';
import { CustomField, SystemField, SystemFieldType } from '../../../hooks/item-fields/types';
import { Field } from '../../../pages/Kits/Overview/python.hooks';
import { KitInfo } from '../../Info/KitInfo/KitInfo';
import getDefaultValueForKitField from '../helpers/get-default-value-for-kit-field';
import { CardTag } from './ItemPreview.styles';
import { usePreviewFields } from './use-preview-fields';

const getDefaultValue = (fieldId: string) => getDefaultValueForKitField(fieldId as Field);

type Props = {
	viewType: 'table' | 'cards' | 'scheduler';
	fieldIds: string[];
	getFieldById: (fieldId: string) => SystemField<SystemFieldType> | CustomField | undefined;
};

const RowPreview: FC<Omit<Props, 'viewType'>> = ({ fieldIds, getFieldById }) => {
	const fields = usePreviewFields(fieldIds, getFieldById, getDefaultValue);

	return (
		<Stack vertical tw="w-full">
			<CardTag size="small">Preview</CardTag>
			<Card tw="px-4 py-3 relative">
				<Stack spacing="tight" tw="overflow-hidden">
					<Image alt="kit preview" fit="contain" src={kitPreviewLogo} tw="h-[40px] w-[40px]" />
					<Stack vertical tw="overflow-hidden">
						<Text weight="bold">Canon EOS R5 Starter Kit</Text>
						<KitInfo extraFields={fields} />
					</Stack>
				</Stack>
			</Card>
		</Stack>
	);
};

const CardPreview: FC<Omit<Props, 'viewType'>> = ({ fieldIds, getFieldById }) => {
	const fields = usePreviewFields(fieldIds, getFieldById, getDefaultValue);

	return (
		<Stack vertical tw="w-80">
			<CardTag size="small">Preview</CardTag>
			<Card tw="relative">
				<Image src={kitPreviewLogo} alt="Kit preview image" tw="h-52 mt-6" fit="contain" />
				<Card.Footer>
					<Stack vertical spacing="tight">
						<Text weight="bold">Canon EOS R5 Starter Kit</Text>
						<KitInfo extraFields={fields} />
					</Stack>
				</Card.Footer>
			</Card>
		</Stack>
	);
};

const KitPreview: FC<Props> = ({ viewType, ...props }) => {
	switch (viewType) {
		case 'scheduler':
		case 'table':
			return <RowPreview {...props} />;
		case 'cards':
			return <CardPreview {...props} />;
		default:
			return null;
	}
};

export default KitPreview;
